import { MultimediaType } from '../../enums/multimedia-type';

export const isDocumentType = (type: MultimediaType): boolean => {
  return type === MultimediaType.Document;
};
